import { render, staticRenderFns } from "./PartnerInfo.vue?vue&type=template&id=ec01cfbc&scoped=true"
import script from "./PartnerInfo.vue?vue&type=script&lang=js"
export * from "./PartnerInfo.vue?vue&type=script&lang=js"
import style0 from "./PartnerInfo.vue?vue&type=style&index=0&id=ec01cfbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec01cfbc",
  null
  
)

export default component.exports